import { useMutation, useQueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { WorkspaceMember } from '../../../api/workspaces/getWorkspaceMembers';
import { changeWorkspaceRole } from '../../../api/workspaces/permissions/changeRole/changeRole';

export const useChangeWorkspaceRole = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeWorkspaceRole,
    onMutate: ({ workspaceId, userId, role }) => {
      const members = queryClient.getQueryData<Array<WorkspaceMember>>(
        workspaceKeys.members(workspaceId)
      );

      if (!members) return { originalMember: null };

      const originalMembers = [...members];

      const newMembers = produce(members, (draft) => {
        const index = draft.findIndex(
          (workspaceMember) => workspaceMember.id === userId
        );
        if (index !== -1) draft[index].role = role;
      });

      queryClient.setQueryData<Array<WorkspaceMember>>(
        workspaceKeys.members(workspaceId),
        newMembers
      );
      return { originalMembers };
    },
    onError: (error, variables, { originalMember }) => {
      if (originalMember !== null) {
        queryClient.setQueryData<Array<WorkspaceMember>>(
          workspaceKeys.members(workspaceId),
          originalMember
        );
      }
    },
    onSettled: () =>
      queryClient.invalidateQueries(workspaceKeys.members(workspaceId)),
  });
};
